import { Component, Input, OnInit } from '@angular/core';
import { faGasPump, faMapMarkedAlt, faTruck, faUsers } from '@fortawesome/free-solid-svg-icons';

import { EmergencyEventOverviewVm } from 'app/shared/generated/Dashboard/Models/EmergencyEventOverviewVm';

@Component({
    selector: 'pcg-emergency-event-banner-card',
    templateUrl: './emergency-event-banner-card.component.html',
    styleUrls: ['./emergency-event-banner-card.component.scss'],
    standalone: false
})
export class EmergencyEventBannerCardComponent implements OnInit {

	@Input() model: EmergencyEventOverviewVm;

	faUsers = faUsers;
	faTruck = faTruck;
	faGasPump = faGasPump;
	faMapMarkedAlt = faMapMarkedAlt;

	constructor() { }

	ngOnInit(): void { }
}
